module.exports = __webpack_public_path__ + "static/media/how-it-works-lubricants-1.b0ca46ae.png";